// Section: Header Component
import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header 
      className={`header ${isScrolled ? 'header-scrolled' : ''}`}
    >
      <nav className="nav-container">
        <div className="nav-content">
          {/* Logo */}
          <div className="logo-container">
            <a 
              href="#hero" 
              className="logo-link"
            >
              Levent Dalğın Medya Ajansı
            </a>
          </div>

          {/* Navigation Menu */}
          <div className="nav-menu">
            <a 
              href="#hizmetler" 
              className="nav-link"
            >
              Hizmetler
            </a>
            <a 
              href="#referanslar" 
              className="nav-link"
            >
              Referanslar
            </a>
            <a 
              href="#iletisim" 
              className="nav-link"
            >
              İletişim
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={toggleMobileMenu}
            className="mobile-menu-button"
          >
            <svg className="menu-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
          <div className="mobile-menu-content">
            <a 
              href="#hizmetler" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="mobile-nav-link"
            >
              Hizmetler
            </a>
            <a 
              href="#referanslar" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="mobile-nav-link"
            >
              Referanslar
            </a>
            <a 
              href="#iletisim" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="mobile-nav-link"
            >
              İletişim
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;